import { defineComponent as _defineComponent } from 'vue'
import { withDefaults } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    isActive: { type: Boolean, default: false }
  },
  emits: ['toggle-click'],
  setup(__props: any, { emit: emits }) {

const props = __props as { isActive: boolean }




function toggleClick() {
  emits('toggle-click')
}

return { __sfc: true,emits, props, toggleClick }
}

})